export function PageSpinner() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[60vh] items-center justify-center bg-surface"
    >
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-outline-variant border-t-primary" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
